/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodLookDown = createReactComponent("outline", "mood-look-down", "IconMoodLookDown", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 13h.01", "key": "svg-1" }], ["path", { "d": "M15 13h.01", "key": "svg-2" }], ["path", { "d": "M11 17h2", "key": "svg-3" }]]);

export { IconMoodLookDown as default };
//# sourceMappingURL=IconMoodLookDown.mjs.map
